import { FoodParamType } from './constants/food-type'
import { ProductTag } from './schemas/product/product-tag'
import { ProductsSortType } from './schemas/product/products-query'

export const AppRoutes = {
  home: () => '/',
  search: (params?: { keyword?: string }) =>
    `/search${params?.keyword ? `?q=${encodeURIComponent(params.keyword)}` : ''}`,
  products: ({
    categoryId,
    subCategoryId,
    tag,
  }: {
    categoryId?: string
    subCategoryId?: string
    tag?: ProductTag['code']
  }) => {
    if (categoryId && subCategoryId) {
      return `/products?category=${categoryId}&subCategory=${subCategoryId}`
    }
    if (categoryId && tag) {
      return `/products?category=${categoryId}&tag=${tag}`
    }
    if (categoryId) {
      return `/products?category=${categoryId}`
    }

    return '/products'
  },
  happyManwon: () => '/happy-manwon',
  todays: () => '/todays',

  product: (id: string) => `/products/${id}`,
  myPage: () => {
    return '/my'
  },
  withdraw: () => {
    return '/my/withdraw'
  },
  confirmWithdraw: (queryString: string) => {
    return `/my/withdraw/confirm/${queryString}`
  },
  myNotifications: () => {
    return '/my/notifications'
  },
  mySettings: () => {
    return '/my/settings'
  },
  brands: (id?: string) => {
    return id ? `/brands?id=${id}` : '/brands'
  },

  signIn: (callbackUrl?: string) => {
    if (!callbackUrl) {
      return '/sign-in'
    }
    return `/sign-in?callbackUrl=${encodeURIComponent(callbackUrl)}`
  },

  signUp: () => {
    return '/sign-up'
  },

  // 똑소 2.0

  nowLowest: ({
    type,
    sort,
    tag,
  }: {
    type: FoodParamType
    sort?: ProductsSortType
    tag?: ProductTag['code']
  }) => `/now-lowest?type=${type}&sort=${sort}&tag=${tag}`,
  foodHall: (type: FoodParamType) => `/food-hall/${type}`,
  hotDeal: (type: FoodParamType) => `/hot-deal/${type}`,
  best: ({ type, period }: { type: FoodParamType; period: 'week' | 'month' }) =>
    `/${period}/best?type=${type}`,
}

export const PROTECTED_ROUTES = [
  AppRoutes.myPage(),
  AppRoutes.withdraw(),
  AppRoutes.confirmWithdraw(''),
  AppRoutes.myNotifications(),
  AppRoutes.mySettings(),
]

export const ROOT = '/'
